import {Component, Input, OnInit} from '@angular/core';
import {IContextMenuOption} from './context-menu.types';

@Component({
    selector: 'npa-context-menu',
    templateUrl: './context-menu.component.html',
    styleUrls: ['./context-menu.component.styl']
})
export class ContextMenuComponent implements OnInit {
    @Input() options: IContextMenuOption[];
    @Input() data: any;
    title: string;
    @Input() iconType: string;

    constructor(){
        this.iconType=this.iconType? this.iconType : 'more_horiz';
    }
    ngOnInit(): void {
    }

    displayTitle(option: IContextMenuOption, data: any) {
        if (option.titleCb) {
            return option.titleCb.call(this, data);
        } else {
            return option.title;
        }
    }
}
